window.jQuery = $;
window.$ = $;
require('@rails/ujs').start();
require('turbolinks').start();
require('bootstrap/dist/js/bootstrap');
require('packs/modals');
require('jquery-validation/dist/jquery.validate');

import Inputmask from 'inputmask';
$(document).on('turbolinks:load', function () {
  var selector = document.getElementById('cr_no');
  // Inputmask({ mask: '9999-9999-9999-9999' }).mask(selector);
  var exp = document.getElementById('exp');
  if (exp) Inputmask({ mask: '99/99' }).mask(exp);
  // Radio button
  $('.radio-group .radio').click(function () {
    $(this).parent().find('.radio').removeClass('selected');
    $(this).addClass('selected');
  });

  $(window).resize(function () {
    if ($(window).width() <= 600) {
      $('#prop-type-group').removeClass('btn-group');
      $('#prop-type-group').addClass('btn-group-vertical');
    } else {
      $('#prop-type-group').addClass('btn-group');
      $('#prop-type-group').removeClass('btn-group-vertical');
    }
  });

  // validation plugin
  $.validator.setDefaults({
    errorElement: 'span',
    errorPlacement: function (error, element) {
      error.addClass('invalid-feedback');
      element.closest('.form-group').append(error);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass('is-invalid');
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass('is-invalid').addClass('is-valid');
    },
  });
  $('.validate').validate();
});
